import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import ListaImprese from './pages/admin/ListaImprese';
import SchedaImpresa from './pages/admin/SchedaImpresa';
import FormImpresa from './pages/admin/FormImpresa';
import IndiciIstat from './pages/admin/IndiciIstat';
import TabellaInail from './pages/admin/TabellaInail';
import ListaImpreseSOA from './pages/admin/ListaImpreseSOA';
import SchedaImpresaSOA from './pages/admin/SchedaImpresaSOA';
import PortaleImpresa from './pages/impresa/PortaleImpresa';
import Importazione from './pages/admin/Importazione';
import GestioneUtenti from './pages/admin/GestioneUtenti';
import GruppoImpresa from './pages/admin/GruppoImpresa';
import Documenti from './pages/admin/Documenti';
import Dashboard from './pages/admin/Dashboard';
import Pagamenti from './pages/admin/Pagamenti';
import CalcoloCorrispettivo from './pages/CalcoloCorrispettivo';
import CambiaPassword from './pages/CambiaPassword';

function PrivateRoute({ children, ruolo }) {
  const { utente, loading } = useAuth();
  if (loading) return <div className="flex items-center justify-center min-h-screen text-[#1A3A5C]">Caricamento...</div>;
  if (!utente) return <Navigate to="/login" replace />;
  if (ruolo && utente.ruolo !== ruolo) return <Navigate to="/" replace />;
  return <Layout>{children}</Layout>;
}

function HomeRedirect() {
  const { utente, loading } = useAuth();
  if (loading) return null;
  if (!utente) return <Navigate to="/login" replace />;
  return <Navigate to={utente.ruolo === 'admin' ? '/admin/dashboard' : '/impresa/dati'} replace />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomeRedirect />} />
          <Route path="/login" element={<Login />} />

          {/* Comune a tutti gli utenti autenticati */}
          <Route path="/cambia-password" element={<PrivateRoute><CambiaPassword /></PrivateRoute>} />

          {/* Admin */}
          <Route path="/admin/dashboard" element={<PrivateRoute ruolo="admin"><Dashboard /></PrivateRoute>} />
          <Route path="/admin/imprese" element={<PrivateRoute ruolo="admin"><ListaImprese /></PrivateRoute>} />
          <Route path="/admin/gruppo-impresa/:nome" element={<PrivateRoute ruolo="admin"><GruppoImpresa /></PrivateRoute>} />
          <Route path="/admin/imprese/:id" element={<PrivateRoute ruolo="admin"><SchedaImpresa /></PrivateRoute>} />
          <Route path="/admin/imprese/:id/modifica" element={<PrivateRoute ruolo="admin"><FormImpresa /></PrivateRoute>} />
          <Route path="/admin/indici-istat" element={<PrivateRoute ruolo="admin"><IndiciIstat /></PrivateRoute>} />
          <Route path="/admin/tabella-inail" element={<PrivateRoute ruolo="admin"><TabellaInail /></PrivateRoute>} />
          <Route path="/admin/importazione" element={<PrivateRoute ruolo="admin"><Importazione /></PrivateRoute>} />
          <Route path="/admin/imprese-soa" element={<PrivateRoute ruolo="admin"><ListaImpreseSOA /></PrivateRoute>} />
          <Route path="/admin/imprese-soa/:id" element={<PrivateRoute ruolo="admin"><SchedaImpresaSOA /></PrivateRoute>} />
          <Route path="/admin/utenti" element={<PrivateRoute ruolo="admin"><GestioneUtenti /></PrivateRoute>} />
          <Route path="/admin/documenti" element={<PrivateRoute ruolo="admin"><Documenti /></PrivateRoute>} />
          <Route path="/admin/pagamenti" element={<PrivateRoute ruolo="admin"><Pagamenti /></PrivateRoute>} />
          <Route path="/admin/corrispettivo/:tipo" element={<PrivateRoute ruolo="admin"><CalcoloCorrispettivo /></PrivateRoute>} />

          {/* Portale impresa */}
          <Route path="/impresa/dati" element={<PrivateRoute ruolo="impresa"><PortaleImpresa /></PrivateRoute>} />
          <Route path="/impresa/corrispettivo/:tipo" element={<PrivateRoute ruolo="impresa"><CalcoloCorrispettivo /></PrivateRoute>} />
          <Route path="/impresa/*" element={<Navigate to="/impresa/dati" replace />} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
